"use client";
import { GLOBAL_SEARCH_RESULTS_SECTIONS } from "@/utils/constant";
import { useStats } from "@dxp-feed/algolia";
import { useEffect } from "react";
import { useTrendingItems } from "@/utils/hooks/useTrendingItems";

interface TabViewProps extends React.PropsWithChildren {
  readonly changeCounterPerIndex: (
    key: GLOBAL_SEARCH_RESULTS_SECTIONS,
    val: number
  ) => void;
  searchQuery?: string | undefined;
  readonly title: GLOBAL_SEARCH_RESULTS_SECTIONS;
}

export default function TabView({
  changeCounterPerIndex,
  children,
  title,
  searchQuery = "",
}: Readonly<TabViewProps>): JSX.Element {
  const { nbHits } = useStats();
  const { data: popularItems } = useTrendingItems(!searchQuery);

  const getCount: any = searchQuery
    ? nbHits
    : popularItems?.[title]?.hits.length;
  useEffect(() => {
    changeCounterPerIndex(title, getCount);
  }, [getCount]);

  return <>{children}</>;
}
